export enum VehicleVersionChoiceType {
  UNSET,
  MATCH,
  DECLUTCH,
}

export type DefaultVehicleVersion = {
  category?: string;
  energy?: string;
  doors?: number;
  gearbox?: string;
  fiscalHorsePower?: number;
};

export type VehicleVersionFields = {
  make?: string;
  model?: string;
  category?: string;
  energy?: string;
  doors?: number;
  gearbox?: string;
  motorizationFull?: string;
  trimLevel?: string;
  cubic?: number; // ONLY MOTO
  fiscalHorsePower?: number;
  version?: string;
};

export type VehicleVersionFieldsList = Record<keyof VehicleVersionFields, string[]>;

export type VehicleVersionBodyFields = {
  internalColor?: string;
  externalColor?: string;
  paintType?: string;
  seatMaterial?: string;
};

export type VehicleVersionBodyFieldsList = Record<keyof VehicleVersionBodyFields, { label: string; value: string }[]>;

export type VehicleVersionStateFields = {
  imported?: boolean;
  firstHand?: boolean;
  mileage?: number;
  referencePro?: string;
  condition?: VehicleCondition;
};

export type VehicleVersion = VehicleVersionFields & {
  firstCirculationDate?: Date;
} & VehicleVersionStateFields &
  VehicleVersionBodyFields;

export const VehicleConditionOptions = ['TO_REPAIR', 'AVERAGE', 'GOOD', 'VERY_GOOD'] as const;
export type VehicleCondition = typeof VehicleConditionOptions[number];
